<template>
  <div id="miss" class="ys-page">
    <el-card shadow="never" class="ys-search-box">
      <div style="display: flex; justify-content: space-between;">
        <el-form :inline="true" class="query_form" size="mini">
          <el-form-item label="大类" prop="brand.selected">
            <select-multiple class="query_form_item" :select-data="queryForm.brand"
              :change="brandChange"></select-multiple>
          </el-form-item>
          <el-form-item label="小类" prop="brandType.selected">
            <select-multiple class="query_form_item" :select-data="queryForm.brandType"></select-multiple>
          </el-form-item>
          <el-form-item label="品牌" prop="financialBrand.selected">
            <select-multiple class="query_form_item" :select-data="queryForm.financialBrand"></select-multiple>
          </el-form-item>
            <el-checkbox style="margin-top: 4px;" v-model="queryForm.isContainBack.selected" true-label="Y" false-label="N"
              @change="onSubmit()">过滤0库存商品</el-checkbox>
        </el-form>
        <div>
          <el-button type="primary" @click="onSubmit()">查询</el-button>
          <el-button type="primary" plain @click="reset()">重置</el-button>
        </div>
      </div>
      <div>
        <span>共漏盘{{ total }}个商品</span>
        <span style="color: #FF8940;">(查询范围中存在，盘点单中不存在的商品)</span>
      </div>
    </el-card>
    <div class="table" v-loading="loading">
      <el-table ref="tableRef" :data="tableData" size="mini" style="width: 100%" border stripe height="100%" max-height="100%" row-key="billNo" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" reserve-selection></el-table-column>
        <el-table-column type="index" width="55" align="center"></el-table-column>
        <el-table-column prop="itemName" label="商品" min-width="130" align="center"></el-table-column>
        <el-table-column prop="convertUnit" label="转换关系" width="100" align="center"></el-table-column>
        <el-table-column prop="onhandQtyQtyFormat" label="库存" width="100" align="center"></el-table-column>
        <el-table-column prop="financialBrandName" label="品牌" width="100" align="center"></el-table-column>
        <el-table-column prop="brandName" label="大类" width="100" align="center"></el-table-column>
        <el-table-column prop="itemTypeName" label="小类" width="100" align="center"></el-table-column>
        <el-table-column prop="salBarCode" label="大单位条码" min-width="144"></el-table-column>
        <el-table-column prop="midBarCode" label="中单位条码" min-width="144"></el-table-column>
        <el-table-column prop="invBarCode" label="小单位条码" min-width="144"></el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <span>共勾选 {{ selection.length }} 个商品</span>
      <div class="footer-right">
        <div style="display: flex; align-items: center;">
          <span>共<span style="font-weight: 500;font-size: 16px;color: #4075e6;margin: 0 4px;">{{ total }}</span>条</span>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.page" :page-sizes="[30, 50, 100, 200]" :page-size="params.size" layout="sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
        <el-button type="primary" size="mini" style="margin-left: 16px;" @click="exportExcelCommon(params, '/erpnew/account/c/reada46ceb/invCheck/itemListExcelReport', '漏盘核查.xlsx', $refs.tableRef)">导出Excel</el-button>
        <el-button type="primary" plain size="mini" @click="addTable">添加到盘点单</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { exportExcelCommon } from '@/assets/js/common.js'
export default {
  name: "miss",
  props: {
    args: {
      type: Object,
      default: () => { return {} }
    },
    filterData: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      queryForm: {
        financialBrand: { submitName: 'itemBrandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择品牌', request: { url: 'Account/dataSearch/selectFinanceBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isEnabled: 'Y' }, text: '', value: '' } },
        brand: { submitName: 'brandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择大类', request: { url: '/Account/dataSearch/selectBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
        brandType: { submitName: 'itemTypeID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: true, list: [], placeholder: '请选择小类', request: { url: '/Account/dataSearch/selectTypeListNewForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
        isContainBack: { submitName: 'filterInvItem', selected: 'Y' },
      },
      tableData: [],
      selection: [],
      params: {
        size: 20,
        current: 1,
        itemTypeIds: '',
        brandIDs: '',
        financialBrandIDs: '',
        filterInvItem: 'Y',
        ...this.args
      },
      total: 0,
      loading: false
    }
  },
  created() {
    this.getTableList()
  },
  methods: {
    onSubmit() {
      this.params.itemTypeIds = this.queryForm.brandType.selected.map(i => `'${i.value}'`).join(',')
      this.params.brandIDs = this.queryForm.brand.selected.map(i => `'${i.value}'`).join(',')
      this.params.financialBrandIDs = this.queryForm.financialBrand.selected.map(i => `'${i.value}'`).join(',')
      this.params.filterInvItem = this.queryForm.isContainBack.selected
      this.getTableList()
    },
    reset() {
      this.queryForm.brand.selected = []
      this.queryForm.brandType.selected = []
      this.queryForm.financialBrand.selected = []
      this.queryForm.isContainBack.selected = 'Y'
      this.onSubmit()
    },
    async getTableList() {
      this.loading = true
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/invCheck/drainCapItemList', { ...this.params, itemList: this.filterData })
      this.loading = false
      if (res.code != "0") return this.$message.error(res.message);
      this.tableData = res.data.itemSearchList.map(i => {
        i['text'] = i.itemName
        i['value'] = i.itemID
        return i
      });
      this.total = res.data.count;
    },
    brandChange(val) {
      let str = val.map(item => "'" + item.value + "'").join(',')
      this.queryForm.brandType.request.params['brandID'] = str
      this.queryForm.brandType.isReSearch = true
    },
    handleSelectionChange(val) {
      this.selection = val
    },
    handleSizeChange(newSize) {
      this.params.size = newSize
      this.getTableList()
    },
    handleCurrentChange(newPage) {
      this.params.current = newPage
      this.getTableList()
    },
    addTable() {
      this.$emit('get-product-data', this.selection)
    },
    exportExcelCommon(param, exportUrl, fileName, table) {
      exportExcelCommon(param, exportUrl, fileName, table)
    }
  }
};
</script>

<style scoped lang="less">
  #miss {
    max-height: 800px;
    padding: 12px;
    .table {
      height: 60vh;
      min-height: 200px;
    }
    .footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 8px 0;
      .footer-right {
        display: flex;
      }
    }
    ::v-deep .el-pagination {
      text-align: right;
      .el-pager {
        li.active {
          color: #4075E6;
        }
        li {
          background: #f2f2f2;
        }
      }
      .el-pagination__sizes {
        .el-input__inner {
          border: none;
          background-color: #f2f2f2;
          border-radius: 218px;
          background: #f2f2f2;
          box-shadow: none;
          color: #666;
        }
      }
      .btn-prev {
        border-top-left-radius: 218px;
        border-bottom-left-radius: 218px;
        margin-left: 20px;
        background: #f2f2f2;
      }
      .btn-next {
        border-top-right-radius: 218px;
        border-bottom-right-radius: 218px;
        background: #f2f2f2;
      }
      .el-pagination__jump {
        .el-input__inner {
          // border: none;
          background-color: #f2f2f2;
          border-radius: 218px;
          background: #f2f2f2;
          box-shadow: none;
          color: #666;
        }
      }
    }
    ::v-deep .el-checkbox {
      .el-checkbox__input.is-indeterminate {
        .el-checkbox__inner {
          background-color: #4075E6;
          border-color: #4075E6;
        }
      }
      &.is-checked {
        .el-checkbox__label {
          color: #4075E6;
        }
        .el-checkbox__inner {
          background-color: #4075E6;
          border-color: #4075E6;
        }
      }
    }
  }
</style>